module.exports = __webpack_public_path__ + "static/media/blog1_web.41510bcd.webp";